import { useMutation, useQuery, useQueryClient } from "react-query";
import { http } from "./axios";


// sent message 
export function useSendMessage(){
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload) => {
            const { data } = await http.post("/api/customers/sent-message-to-customer", payload);
            queryClient.invalidateQueries(["messages", payload?.user_id]);
            queryClient.invalidateQueries(["chats-list"]);
            return data;
        }
    })
}

// get messages by user id with use query
export function useGetMessages(userId){

    return useQuery({
        queryKey: ["messages", userId],
        queryFn: async () => {
            const { data } = await http.get(`/api/customers/get-chats-by-user-id/${userId}`);

            return data;
        },
        enabled:userId !== null,
        // Poll while a conversation is open so new customer messages show up
        // without relying solely on the Firebase realtime signal.
        refetchInterval: userId !== null ? 10000 : false,
    });
}


export function useUserUnreadMsgCount(){
    return useQuery({
        queryKey: ["message-count"],
        queryFn: async () => {
            const { data } = await http.get(`/api/customers/unread-user-msg-count`);
            return data;
        },
        // Firebase realtime ping is the fast path, but poll too so the badge
        // still updates if that signal doesn't land.
        refetchInterval: 15000,
    });
}

// get all user list
export function useGetUsers({ search }){
    return useQuery({
        queryKey: ["chat-users", search],
        queryFn: async () => {
            const { data } = await http.get(`/api/customers/search-customers-for-chats?search=${search}`);
            return data;
        },
    })
};

// get all chats list
export function useGetChats(){
    return useQuery({
        queryKey: ["chats-list"],
        queryFn: async () => {
            const { data } = await http.get("/api/customers/customer-admin-chats");
            return data;
        },
        // Keep the conversation list (last message, unread state) fresh while
        // the Help & Support page is open.
        refetchInterval: 10000,
    })
};


// get product details by id or slug

export function useProduct(id){
    return useQuery({
        queryKey: ["products-slug-or-id", id],
        queryFn: async () => {
            const { data } = await http.get(`/api/products/get_product_details/${id}`);
            return data;
        },
        enabled: id!== null ? true : false,
    })
};